import BodyText from '@lyra/core/components/BodyText'
import Heading from '@lyra/core/components/Heading'
import { X } from '@lyra/core/components/Icon'
import SelectableCard from '@lyra/core/components/SelectableCard'
import { Announcement } from '@lyra/web/constants/announcements'
import Image from 'next/image'
import { StackProps, XStack, YStack } from 'tamagui'

import TrackButton from '../../../components/common/TrackButton'

type Props = {
  announcement: Announcement
  onDismiss: () => void
} & StackProps

export default function HomeAnnouncementCard({
  announcement: { id, title, description, href, target, imageUrl },
  onDismiss,
  ...styleProps
}: Props) {
  return (
    <SelectableCard {...styleProps} cursor="pointer" href={href} target={target}>
      <XStack marginBottom="$4" justifyContent="space-between" alignItems="flex-start">
        <Image src={imageUrl} alt={id} height={60} width={60} />
        <TrackButton
          size="sm"
          icon={<X />}
          onPress={(e) => {
            e.stopPropagation()
            e.preventDefault()
            onDismiss()
          }}
          eventName="announcement-dismiss"
          eventProperties={{ id }}
        />
      </XStack>
      <YStack gap="$1">
        <Heading>{title}</Heading>
        <BodyText color="secondary">{description}</BodyText>
      </YStack>
    </SelectableCard>
  )
}
